import styled from 'styled-components';
import Text from '@rsos/components/capstone/base/Text';

export const DeclineListWrapper = styled.div`
  position: absolute;
  bottom: 0;
  width: ${({ paneWidth }) => `${paneWidth}px`};
  padding: 10px;
  background-color: ${({ theme }) => theme.colors.foreground};
  border-top: 1px solid ${({ theme }) => theme.colors.heavyLineOutline};
  font-size: 12px;
  z-index: 15; // ensure the div displays above the chat avatar component
`;

export const DeclineTitle = styled(Text).attrs({
  margin: '5px 0 10px 0',
  color: 'primaryText',
  fontWeight: 'bold',
})``;

export const DeclineOtherReason = styled(Text).attrs({
  marginY: '10px',
  color: 'primaryText',
  textAlign: 'center',
  cursor: 'pointer',
})``;

export const SendDeclineMessageButton = styled.div`
  position: absolute;
  bottom: 0;
  right: 12px;
  height: 30px;
  border: none;
  color: ${({ theme }) => theme.colors.primaryBase};
  line-height: 30px;
  cursor: pointer;
`;
